export const DSViewModeAPISymbol = Symbol('DSViewModeAPISymbol')
